import React, { useEffect } from "react";
import "./headerFooterStyles.css";

const HeaderFooterComponent = ({ title, data, triggerAction, onComplete }) => {
  const openPreviewWindow = (htmlContent) => {
    const previewWindow = window.open("", "_blank");
    const fullHtml = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="UTF-8" />
          <title>${title || "Document Preview"}</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin-left: 20px;
              margin-right: 20px;
              background-color: #fff;
              color: #000;
            }
            .print-content {
              padding-left: 20px;
              padding-right: 20px;
              box-shadow: 0 0 5px rgba(0,0,0,0.1);
            }
            @media print {
              body {
                margin: 0;
              }
              .print-content {
                box-shadow: none;
                border: none;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-content">${htmlContent}</div>
        </body>
      </html>
    `;

    previewWindow.document.open();
    previewWindow.document.write(fullHtml);
    previewWindow.document.close();
    previewWindow.focus();
  };

  useEffect(() => {
    if (!data || !triggerAction) return;
    console.log("HeaderFooterComponent triggered with action:", triggerAction);

    const handlePrint = () => {
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="UTF-8" />
            <title>${title} - Print</title>
          </head>
          <body>
            <div class="print-content">${data}</div>
          </body>
        </html>
      `);
      doc.close();

      iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        iframe.contentWindow.onafterprint = () => {
          document.body.removeChild(iframe);
          onComplete?.(); // Clear state after print
        };
      };
    };

    if (triggerAction === "print") {
      handlePrint();
      onComplete?.(); // Clear state after preview
    } else if (triggerAction === "preview") {
      openPreviewWindow(data);
      onComplete?.(); // Clear state after preview
    }
  }, [data, triggerAction, title, onComplete]);

  return null; // no visible component needed
};

export default HeaderFooterComponent;
